<template>
    <section>
        <div>
            
            <div class="t-body3 mgt-6 t-color-content1">
                {{$t('32')}}
                <!-- 계정 찾기를 위한 코드를 받을 방법을 선택하세요. -->
            </div>
            <div class="mgt-8">
                <div class="mgt-30" v-for="(method, index) in findId.authMethods" :key="index">
                    <!-- {{method}} -->
                    <div class="mdc-form-field">
                        <div class="mdc-radio radio-red">
                            <input class="mdc-radio__native-control" type="radio" 
                                name="findType"
                                :id="'findType'+method.findWay.value"
                                :value="method.findWay.value"
                                v-model="findType"
                                @click="setValue(method.value)"
                                >
                            <div class="mdc-radio__background">
                                <div class="mdc-radio__outer-circle"></div>
                                <div class="mdc-radio__inner-circle"></div>
                            </div>
                        </div>
                        <label :for="'findType'+method.findWay.value" v-if="method.findWay.value === 'SMS'" class="t-body1">
                            {{$t('33')}}
                            <!-- {{method.findWay.value}}로 찾기 -->
                        </label>
                        <label :for="'findType'+method.findWay.value" v-else-if="method.findWay.value === 'EMAIL'" class="t-body1">
                            {{$t('34')}}
                            <!-- {{method.findWay.value}}로 찾기 -->
                        </label>
                    </div>
                    <div class="t-body3 h-20 t-color-gray4 radio-addon-label">{{method.value}}</div>
                </div>
                
            </div>
            <div class="mgt-38">
                <button class="mdc-button mdc-button--raised btn-red" @click="getCertiNumber()">
                    {{$t('35')}}
                    <!-- 코드 받기 -->
                </button>
                <button class="mdc-button btn-white mgr-8 mgl-8" @click="cancelFindId()" type="button">
                    {{$t('36')}}
                    <!-- 취소 -->
                </button>
            </div>
        </div>
    </section>
</template>

<script>
/**
 * 계정 찾기 Step3 컴포넌트 (find account Step3 component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import {MDCRipple} from '@material/ripple'
import findApi from '@/api/findApi.js'
import {mapState, mapMutations} from 'vuex'
import {findIdMixin} from '../../mixins/findId.js'

export default {
    data() {
        return {
            findType: '',
            value: ''
        }
    },

    mixins: [findIdMixin],

    computed: {
        ...mapState('findId',{
            findId : state => state,
        })
    },

    mounted() {
        // 인증 수단이 없을 경우 Step1로 이동(If there is no authentication method, go to Step1)
        if (!this.findId.authMethods.length) {
            this.$moveLogin()
        }
        this.setMaterialUi()
                
    },

    methods: {
        // Store 변이 정의(define store mutation)
        ...mapMutations('findId', ['SET_STEP2','SET_STEP3']),

        setMaterialUi() {
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },

        // 인증수단 설정(Authentication method setting)
        setValue(value) {
            this.value = value
        },
        
        // 인증번호 발송 API 호출(Authentication number sending API call)
        getCertiNumber() {
            if (!this.findType || !this.value){
                this.$snackOpen({
                    contents: this.$t('32')
                }).then(() => {})
                // this.$snackOpen({contents:'계정 찾기를 위한 코드를 받을 방법을 선택하세요.'}).then(() => {})
                return
            }

            let params = {
                findWay: this.findType,
                value: this.value
            }

            this.SET_STEP2(params)

            let responseData = null

            // set certi number
            findApi.requestFindId(params).then((response) => {
                responseData = response.data.data
                this.SET_STEP3({
                    value: this.value,
                    token: responseData.token
                })

                this.$router.push({
                    name: 'FindIdStep4'
                })
            }).catch((err) => {
                responseData = err.response.data.meta
                this.$error({content: responseData.errMsg}).then(() => {})
                
            })
        },
    },
}
</script>